<template>
  <div class="padding">
    <vue_hourly/>

    <div class="box">
      <v-server-table
        ref="datatable"
        :url="api"
        :name="tableName"
        :columns="columns"
        :options="options"/>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

const TableName = 'VUETABLE_HOURLY';
export default {
    data: function() {
        var that = this;
        return {
            tableName: TableName,
            columns: ['time', 'sub_total', 'total_transaction', 'total_sales'],
            options: {
                perPage: 24,
                perPageValues: [24],
                texts: {
                    title: 'Hourly Sales',
                    description: 'Shows hourly sale details',
                },
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until'],
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },
                columnsClasses: {
                    sub_total: 'text-right width-10',
                    total_sales: 'text-right width-10',
                    total_transaction: 'text-right width-10',
                },
                headings: {
                    sub_total: `Sub Total`,
                    total_sales: `Grand Total`,
                    total_transaction: `Total Transaction`,
                },
                pdf_url: Laroute.route('franchise.report.hourly.exportAsFile', {
                    type: 'PDF',
                }),
                csv_url: Laroute.route('franchise.report.hourly.exportAsFile', {
                    type: 'CSV',
                }),
                xls_url: Laroute.route('franchise.report.hourly.exportAsFile', {
                    type: 'XLSX',
                }),
                requestFunction: function(request) {
                    return axios
                        .post(this.url, request)
                        .catch(e => this.dispatch('error', e));
                },
                export_post: true,
                export_filename: 'Hourly Sales Report',
            },
        };
    },

    computed: {
        ...mapState('hourly', ['filters']),
        ...mapGetters('report', ['typeDate']),

        api() {
            return Laroute.route('franchise.report.hourly.hourly', {
                typeDate: this.$store.getters.typeDate,
            });
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;
            this.setFilter();
        },
    },

    methods: {
        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/hourly/vuetable_hourly.vue